import { TextLinkKind,TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { HelpService } from '~src/commonInfra/services/HelpService';

import { Messages } from '../../codegen/Localize';

export function SiteRoleInfoLink() {
  return (<div>
      {Messages.siteRoleDropdownInfo()}
      &nbsp;
      <TextLinkWidget
        testId={'test'}
        target={'_blank'}
        href={HelpService.getServerHelpUrlByCategory('siterole')}
        kind={TextLinkKind.Standalone}
        rel="noopener noreferrer">
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>);
}
